export { default as RecuperarSenhaForm } from './RecuperarSenhaForm';
